import React from "react";
import { Container, Box, TextField, Button, Typography, Paper, Grid } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route, Link, Outlet } from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: { main: "#ff4081" },
    secondary: { main: "#8e44ad" },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

const Login = () => {
  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth={false}
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            backgroundImage: `url(image/background.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            padding: "20px",
          }}
      >
        <Paper
          elevation={10}
          sx={{
            display: "flex",
            width: "100%",
            maxWidth: 900,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {/* Left Section - Login Form */}
          <Box sx={{ width: "50%", p: 4, display: "flex", flexDirection: "column" }}>
            <Box sx={{ mb: 2 }}>
              <img src='/image/Actify365.png' alt="Actify365 Logo" width="150" />
            </Box>
            <Typography variant="h5" fontWeight="600">
              Hello,
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Welcome to <span style={{ color: "red", fontWeight: "bold" }}>Actify365</span> the Real Learning
            </Typography>

            <form action="step1" method="POST">
              <TextField
                fullWidth
                label="Login ID"
                name="loginid"
                defaultValue="1234"
                margin="normal"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                name="password"
                defaultValue="1234"
                margin="normal"
                variant="outlined"
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2, py: 1.5, fontSize: 18 }}
              >
                LET'S GO
              </Button>
            </form>
          </Box>

          {/* Right Section - Image */}
          <Grid
            item
            sx={{
              width: "50%",
              backgroundColor: "secondary.main",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            
            }}
          >
            <img src="/image/kids.png" alt="Happy Kids" style={{ maxWidth: "100%", height: "100%" }} />
          </Grid>
        </Paper>
      </Container>
      <Outlet />
    </ThemeProvider>
    
  );
};

export default Login;
